import { render, staticRenderFns } from "./Msu.vue?vue&type=template&id=3f4618ef&scoped=true"
import script from "./Msu.vue?vue&type=script&lang=js"
export * from "./Msu.vue?vue&type=script&lang=js"
import style0 from "./Msu.vue?vue&type=style&index=0&id=3f4618ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4618ef",
  null
  
)

export default component.exports